import { Box, Divider, Stack, Typography, useTheme } from '@mui/material';
import { searchTypeEnum } from 'constants/dashboard.constants';
import { useAppSelector } from 'hooks/redux.hooks';
import { useMemo } from 'react';
import { selectTranslations } from 'state/reducers/translation.reducers';

interface IProps {
	searchResults: any[];
	searchType: string;
	handleClick: any;
	isHebrewTerm?: boolean;
}

export const SearchResults = ({ searchResults, searchType, handleClick, isHebrewTerm }: IProps) => {
	const t = useAppSelector(selectTranslations);
	const theme = useTheme();

	const resultsAmount = useMemo(() => {
		if (searchType === searchTypeEnum.CONTACT) {
			let initialLength = 0;
			searchResults?.map((result: any) => {
				initialLength += result?.companies?.length;
			});
			return initialLength;
		} else {
			return searchResults?.length;
		}
	}, [searchResults]);

	return (
		<Box
			sx={{
				position: 'absolute',
				width: '-webkit-fill-available',
				marginTop: '5px',
				padding: '8px',
				background: theme.palette.background.paper,
				boxShadow: '0px 4px 4px rgba(18, 86, 79, 0.2)',
				border: `1px solid ${theme.palette.root.lightGreen}`,
				borderRadius: '4px',
				zIndex: 2,
				maxHeight: '270px',
				overflowY: 'auto',
			}}
		>
			{searchResults ? (
				<Stack spacing={1}>
					<Typography sx={{ padding: '5px 12px', color: theme.palette.root.label }}>
						{resultsAmount || '0'} {t('page.dashboard.search.resultsTitle')}
					</Typography>
					<Divider
						orientation="horizontal"
						flexItem
						sx={{ borderBottom: 2, borderColor: theme.palette.root.inputDivider }}
					/>
					{searchResults.map((result: any, index: number) => {
						return (
							<Box key={index}>
								{searchType === searchTypeEnum.CONTACT ? (
									<Stack key={index}>
										{result?.companies?.map((company: any, index: number) => {
											return (
												<Box
													key={index}
													sx={{
														display: 'flex',
														justifyContent: 'space-between',
														cursor: 'pointer',
														padding: '15px',
														'&:hover': {
															background: theme.palette.root.lightGreen,
															borderRadius: '8px',
														},
													}}
													onClick={() => handleClick(result, company)}
												>
													<Typography
														variant="body"
														sx={{
															marginRight: '15px',
															color: theme.palette.root.formTitle,
														}}
													>
														{result.firstName} {'  '} {result.lastName}
													</Typography>
													<Typography variant="body" sx={{ color: theme.palette.root.label }}>
														{company.company.name}
													</Typography>
												</Box>
											);
										})}
									</Stack>
								) : (
									<Box
										key={index}
										onClick={() => handleClick(result)}
										sx={{
											cursor: 'pointer',
											padding: '15px',
											'&:hover': {
												background: theme.palette.root.lightGreen,
												borderRadius: '8px',
											},
										}}
									>
										<Typography variant="body">
											{isHebrewTerm ? result.hebrewName : result.name}
										</Typography>
									</Box>
								)}
							</Box>
						);
					})}
				</Stack>
			) : (
				<Typography>{t('page.dashboard.search.noResults')}</Typography>
			)}
		</Box>
	);
};
